export { default as getThemeHtmlAttrs } from '../get-theme-html-attrs';
